import Layout from "../components/Layout/Layout";

const RefundPolicy = () => {
    return (
    <Layout>
      <div className="container mx-auto p-6 space-y-6 my-10">
      <h1 className="text-4xl font-bold mb-10 text-center">Change, Refund & Return Policy</h1>

      <section>
        <h2 className="text-xl font-semibold mb-2">
          What happens if a student wants to transfer to a different course date, or wants to cancel and receive a refund?
        </h2>
        <p>
          <strong>For classes that are 1-2 days long:</strong> Participants can cancel and apply for a full refund or transfer to a different course date at no cost if ProSafe is notified by email a minimum of 72 hours prior to the start of the course. (Email: <a href="mailto:info@prosafetraining.ca" className="text-blue-500 underline">info@prosafetraining.ca</a>)
        </p>
        <p>
          <strong>For classes that are 3-5 days long:</strong> Participants can cancel and apply for a full refund or transfer to a different course date at no cost if ProSafe is notified by email 5 business days prior to the course start date. (Email: <a href="mailto:info@prosafetraining.ca" className="text-blue-500 underline">info@prosafetraining.ca</a>)
        </p>
        <p>
          <strong>For classes that are 6 or more days long:</strong> Participants can cancel and apply for a full refund or transfer to a different course date at no cost if ProSafe is notified by email 10 business days prior to the course start date. (Email: <a href="mailto:info@prosafetraining.ca" className="text-blue-500 underline">info@prosafetraining.ca</a>)
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-2">
          What happens if a student does not notify ProSafe within the allotted time frame for course cancellation or transfer of date?
        </h2>
        <p>
          A student is not eligible for a refund and is liable for the entire fee, but can still transfer to a different course date if it is done before the start of the course. (Note: A 50% non-refundable administration fee + GST will be charged up to a maximum of $250 + GST.) Course transfers can be done one time only.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-2">What happens when a student is late to class?</h2>
        <p>
          Due to Certification requirements, participants who are late may be ineligible to join the class due to the amount of time and content missed.
        </p>
        <p>Late participants are ineligible for a refund and liable for the entire fee.</p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-2">What happens if a student does not show up on the course date (No-Show)?</h2>
        <p>
          Students are considered a No-show if they register into a spot on a training date and do not notify ProSafe nor attend the course. No-shows are not eligible for a refund and are liable for the entire fee. Course transfers are not permitted for no-shows.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-2">What happens if a student is sick and cannot attend a course?</h2>
        <p>
          If a student cannot attend a course due to illness, a doctor’s note may be required in order to permit a transfer of course date. ProSafe must be notified before the start of the course for them to be transferable.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-2">What happens if ProSafe cancels a course?</h2>
        <p>
          ProSafe reserves the right to cancel a course due to low enrollment or an unforeseen instructor emergency. A minimum number of students is required to run a course. On the rare occasion when a course is canceled due to low enrollment, participants will be offered the opportunity to reschedule to a different course date at no charge or receive a full refund.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-2">What about my FoodSafe Level 1 Online course?</h2>
        <p>
          Refunds must be requested prior to a student starting the course. To receive a refund, please forward your electronic receipt to our customer service department:{" "}
          <a href="mailto:info@prosafefirstaid.ca" className="text-blue-500 underline">
            info@prosafefirstaid.ca
          </a>{" "}
          with the subject heading: “FoodSafe Online Course Refund”. State the reason for your refund request. Refund requests will not be accepted after the student has started the course, or if more than 30 days have passed since purchase. All group purchase sales are considered final.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-2">What happens if a student is unsuccessful in a course?</h2>
        <p>
          If a student is unsuccessful and wants to retake the course, they may re-register for the same course on a new date at a discounted price of 50% of the original fee, up to a maximum of $500 plus applicable taxes. The discount is valid for up to 6 months after the original course. If a student is unsuccessful a second time, any future registrations will be at full price.
        </p>
      </section>
    </div>
    </Layout>
    );
  };
  
  export default RefundPolicy;
  